// extracted by mini-css-extract-plugin
export const anitext = "anitext-module--anitext--1_i8U";
export const commandline = "anitext-module--commandline--1c2K0";
export const cover = "anitext-module--cover--1HnCH";
export const typing = "anitext-module--typing--TlISN";
export const blinkCaret = "anitext-module--blink-caret--BwlO0";